import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const addVendorFare = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/vendorcommission/add-vendor-fare`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const getFareListByCarrierAndVendor = async (vendorId, carrierId) => {
  const data = await httpService.get(
    `${apiUrl}/vendorcommission/fare-list-by-carrier?VendorId=${
      vendorId ? `${vendorId}` : ""
    }&FlightCarrierId=${carrierId ? `${carrierId}` : ""}`
  );
  return data;
};
const updateCarrierFareStatus = async (values) => {
  try {
    const data = await httpService.post(
      `${apiUrl}/vendorcommission/update-carrier-fare-status`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const updateCarrierFareComm = async (values) => {
  try {
    const data = await httpService.post(
      `${apiUrl}/vendorcommission/set-carrier-fare-comm`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const updateVendor = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/vendorcommission/update-vendor/${values.id}`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
////////////////
const getVendorList = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/supplier-master/supplier-settings-list${
        query ? `?${query}` : ""
      }`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const addUpdateVendor = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/supplier-master/manage-supplier-settings`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const getVendorFareList = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/supplier-master/supplier-carrier-settings-list${
        query ? `?${query}` : ""
      }`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const addUpdateAirlines = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/supplier-master/manage-supplier-carrier-settings`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const getVendorSearchForAdd = async (searchText) => {
  try {
    const url = `${apiUrl}/supplier-master/supplier-list/search${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const getFlightSearchForAdd = async (searchText) => {
  try {
    const url = `${apiUrl}/supplier-master/carrier-list/search${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getVendorSearchForUpdate = async (value) => {
  try {
    const url = `${apiUrl}/supplier-master/used-supplier-list/search${value}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const getFlightSearchForUpdate = async (value) => {
  try {
    const url = `${apiUrl}/supplier-master/used-carrier-list/search${value}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getSupplierCommissionList = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/supplier-master/supplier-fare-settings-list${
        query ? `?${query}` : ""
      }`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const addUpdateSupplierCommission = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/supplier-master/manage-supplier-fare-settings`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
export {
  addUpdateAirlines,
  getVendorList,
  getVendorFareList,
  getVendorSearchForAdd,
  getFlightSearchForAdd,
  getVendorSearchForUpdate,
  getFlightSearchForUpdate,
  addVendorFare,
  getFareListByCarrierAndVendor,
  updateCarrierFareStatus,
  updateCarrierFareComm,
  addUpdateVendor,
  updateVendor,
  getSupplierCommissionList,
  addUpdateSupplierCommission,
};
